import { ApiResourceBaseClass as c } from "./baseApiCalls.js";
const i = "sso", s = `${i}/oidc`;
class d extends c {
  /**
   * Generates a unique ID for an OIDC entity.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/sso/oidc/generate_id`
   *
   * @returns {Promise<GenerateOidcUuidResponse>} A promise resolving to the response containing the generated OIDC ID.
   */
  generateOidcId = async () => {
    const { data: t } = await this.post(
      `${s}/generate_id`
    );
    return t;
  };
  /**
   * Creates an OIDC entity using the given ID and request body.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/sso/oidc/{id}`
   *
   * @param {GenerateOidcUuidResponse} id - The generated OIDC ID.
   * @param {OidcBody} oidcBody - The request body containing OIDC entity details.
   * @returns {Promise<Oidc>} A promise resolving to the created OIDC entity.
   */
  createOidc = async (t, a) => {
    const { data: e } = await this.post(`${s}/${t}`, a);
    return e;
  };
  /**
   * Updates an existing OIDC entity using the given ID and request body.
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/sso/oidc/{id}`
   *
   * @param {GenerateOidcUuidResponse} id - The ID of the OIDC entity to update.
   * @param {OidcBody} oidcBody - The request body containing updated OIDC entity details.
   * @returns {Promise<Oidc>} A promise resolving to the updated OIDC entity.
   */
  updateOidc = async (t, a) => {
    const { data: e } = await this.put(`${s}/${t}`, a);
    return e;
  };
  /**
   * Retrieves a specific OIDC entity by its ID.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/sso/oidc/{id}`
   *
   * @param {OidcParam} id - The ID of the OIDC entity to retrieve.
   * @returns {Promise<Oidc>} A promise resolving to the requested OIDC entity.
   */
  getOidc = async (t) => {
    const { data: a } = await this.get(`${s}/${t}`);
    return a;
  };
  /**
   * Retrieves a list of all available OIDC entities.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/sso/oidc`
   *
   * @returns {Promise<OidcListResponse>} A promise resolving to the response containing the list of OIDC entities.
   */
  getOidcs = async () => {
    const { data: t } = await this.get(`${s}`);
    return t;
  };
  /**
   * Fetches prefill data for an OIDC entity creation.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/sso/oidc/prefill`
   *
   * @param {OidcPrefillParams} params - Parameters used to generate prefill data for OIDC creation.
   * @returns {Promise<OidcPrefillResponse>} A promise resolving to the prefill data response.
   */
  getOidcPrefill = async (t) => {
    const { data: a } = await this.post(
      `${s}/prefill`,
      t
    );
    return a;
  };
}
export {
  s as RESOURCE_OIDC_URI,
  d as SsoOidc
};
